export const DEFAULT_10_PAGINATION_MODEL = {
  pageIndex: 0,
  pageSize: 10,
};
